import { render, staticRenderFns } from "./VerticalFlow.vue?vue&type=template&id=afcc1662&scoped=true&"
import script from "./VerticalFlow.vue?vue&type=script&lang=js&"
export * from "./VerticalFlow.vue?vue&type=script&lang=js&"
import style0 from "./VerticalFlow.vue?vue&type=style&index=0&id=afcc1662&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcc1662",
  null
  
)

export default component.exports